import type { LocalizedText } from "@/shared/i18n"

import type { TriggerAction, TriggerRuleMode } from "./types"

export interface TriggerModeConfig {
  mode: TriggerRuleMode
  allowMultipleRules: boolean
  fixedRuleName: string | null
  showRuleNameInput: boolean
  allowRuleRename: boolean
  editorSectionTitle: LocalizedText
  saveButton: LocalizedText
  addButtonLabel: LocalizedText
  emptyStateMessage: LocalizedText
  allowedActionTypes: Array<"punishment" | "send_message" | "support_mode">
  defaultActionType: "punishment" | "send_message" | "support_mode"
  defaultActions: TriggerAction[]
}

export const TRIGGER_MODE_CONFIGS: Record<TriggerRuleMode, TriggerModeConfig> = {
  blacklist: {
    mode: "blacklist",
    allowMultipleRules: true,
    fixedRuleName: null,
    showRuleNameInput: true,
    allowRuleRename: true,
    editorSectionTitle: { key: "word_triggers-editor-title", fallback: "Edit Moderation List" },
    saveButton: { key: "common-save", fallback: "Save" },
    addButtonLabel: { key: "word_triggers-create-list", fallback: "Create list" },
    emptyStateMessage: { key: "word_triggers-empty-state", fallback: "Create your first moderation list" },
    allowedActionTypes: ["punishment", "send_message"],
    defaultActionType: "punishment",
    defaultActions: [
      {
        action_type: "punishment",
        parameters: {
          punishment_kind: "mute",
          duration: "PT1H",
          clean_count: 1,
          warning_threshold: null,
          warning_observation_interval: null,
          skip_notification: false
        }
      }
    ]
  },
  support_mode: {
    mode: "support_mode",
    allowMultipleRules: false,
    fixedRuleName: "support_mode",
    showRuleNameInput: false,
    allowRuleRename: false,
    editorSectionTitle: { key: "support-editor-title", fallback: "Support Mode Triggers" },
    saveButton: { key: "support-save-triggers", fallback: "Save keywords" },
    addButtonLabel: { key: "support-add-trigger", fallback: "Add trigger" },
    emptyStateMessage: { key: "support-empty-state", fallback: "Add keywords that trigger AI responses" },
    allowedActionTypes: ["support_mode"],
    defaultActionType: "support_mode",
    defaultActions: [
      {
        action_type: "support_mode",
        parameters: { force_reply: true }
      }
    ]
  },
  business_mode: {
    mode: "business_mode",
    allowMultipleRules: false,
    fixedRuleName: "business_mode",
    showRuleNameInput: false,
    allowRuleRename: false,
    editorSectionTitle: { key: "business-editor-title", fallback: "Business Mode Triggers" },
    saveButton: { key: "business-save-triggers", fallback: "Save keywords" },
    addButtonLabel: { key: "business-add-trigger", fallback: "Add trigger" },
    emptyStateMessage: { key: "business-empty-state", fallback: "Add keywords that trigger AI responses" },
    allowedActionTypes: ["support_mode"],
    defaultActionType: "support_mode",
    defaultActions: [
      {
        action_type: "support_mode",
        parameters: { force_reply: true }
      }
    ]
  }
}
